/**
 * @generated SignedSource<<7957fd83beac4fdc66a6be0ddaf171a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type columnPicker_issueViewChildIssuesPanel$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer">;
  readonly " $fragmentType": "columnPicker_issueViewChildIssuesPanel";
};
export type columnPicker_issueViewChildIssuesPanel$key = {
  readonly " $data"?: columnPicker_issueViewChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "columnPicker_issueViewChildIssuesPanel",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer"
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "5c5a84aea3906448b229d6db61207ff4";

export default node;
